export function state(initialState) {
  return {
    app: {},
    client: {}, 
    user: {},
  };
}
